import React, { Component } from "react";

const fonts = [
    "Arial",
    "Open Sans",
    "Helvetica",
    "Eurostile",
    "Tahoma",
    // "Comic Sans",
    "Whortle",
    "Festivo",
    // "Iestalogy",
    "Times New Roman",
    "Courier",
    "Impact",
    "Elkwood",
    // "Debussy",
    // "Gloucester",
    // "Rosalia",
    "Kaufmann",
    // "Fraktur",
    // "Bodoni",
    "Embassy",
    // "Lithos",
    // "Geared Slab",
    "Myriad",
    // "MyriadPro",
    // "Aller"
];

export default class ReactFontPicker extends Component {
    render() {
        return (
            <div>
                <ul className="mk-ul">
                    <li id="mk-font-box">
                        <p id="mk-font-box-inner">{this.props.font}</p>
                        <ul className="mk-ul" id="mk-font-list">
                            {fonts.map((font, id) => {
                                return (
                                    <li
                                        onClick={() => {
                                            this.props.reactFontPicker(
                                                font
                                            );
                                        }}
                                        key={id}
                                        className={font}
                                        id="mk-font-item"
                                        style={{fontFamily: font, fontSize: "2em"}}
                                    >
                                        {font}
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}
